<template lang="pug">
v-list(v-if="errorResponse.response.data" )
    v-list-item-group {{ $t('errorResponseViolation.listGroupLabel') }}
    v-list-item(v-for="(violation, idx) in getViolationMessage" :key="idx")
        v-list-item-icon.mx-0
            v-icon(x-small) fas fa-chevron-right
        v-list-item-content {{ violation }}

</template>

<script lang="ts">
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {AxiosError} from 'axios'

@Component({})
export default class ErrorResponseViolations extends Vue {
  @Prop({required: true}) readonly errorResponse!: AxiosError

  private filteredViolations: string[] = []

  get getViolationMessage () {
      this.errorResponse.response!.data.violations.forEach((item: any) => {
          const foundItem = this.filteredViolations.includes(item.message)
          if(foundItem) {
              return
          } else {
              this.filteredViolations.push(item.message)
          }
      })
      return this.filteredViolations
  }


  mounted () {
  }
}


</script>

<style lang="stylus" scoped>

</style>
